import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import { lcvOrdersConstants } from "../../../../../_redux/_constants/lcvOrders.constants";
import { lcvOrdersGetImportHistoryRequest } from "../../../../../_redux/_actions/lcvOrders.action";

// Previous uploads. Paging is a backend parameter, so the response is exactly the page shown.

const INITIAL_PAGE = { skip: 0, take: 10 };

// Mirrors the real row height and the default page size, so the table does not jump when the data
// arrives and the wait does not read as a broken screen.
function LcvOrderImportHistoryGridSkeleton() {
     return (
          <Box>
               {Array.from({ length: INITIAL_PAGE.take }).map((unused, index) => (
                    <Box
                         key={index}
                         sx={{
                              display: "flex",
                              gap: 2,
                              py: 1.5,
                              borderBottom: "1px solid",
                              borderColor: "divider",
                         }}
                    >
                         <Skeleton variant="text" width="42%" />
                         <Skeleton variant="text" width="20%" />
                         <Skeleton variant="text" width="12%" />
                         <Skeleton variant="text" width="12%" />
                         <Skeleton variant="text" width="12%" />
                    </Box>
               ))}
          </Box>
     );
}

export default function LcvOrderImportHistoryGrid() {
     const actionDispatch = useDispatch();

     const history = useSelector((state) => state?.lcvOrders?.importHistory);

     const isLoading = useSelector((state) =>
          (state?.loading?.pendingRequests || []).includes(
               lcvOrdersConstants.LCV_ORDERS_GET_IMPORT_HISTORY_REQUEST,
          ),
     );

     const [page, setPage] = useState(INITIAL_PAGE);

     useEffect(() => {
          actionDispatch(
               lcvOrdersGetImportHistoryRequest({
                    page: Math.floor(page.skip / page.take) + 1,
                    pageSize: page.take,
               }),
          );
     }, [actionDispatch, page]);

     const rows = history?.items || [];

     return (
          <Box sx={{ mt: 4 }}>
               <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                    Previous uploads
               </Typography>

               {isLoading && rows.length === 0 ? (
                    <LcvOrderImportHistoryGridSkeleton />
               ) : (
                    <Grid
                         data={rows}
                         className="sba-area-data-grid"
                         scrollable="none"
                         skip={page.skip}
                         take={page.take}
                         total={history?.totalCount || 0}
                         pageable={{ buttonCount: 4, pageSizes: [10, 25, 50] }}
                         onPageChange={(event) => setPage(event.page)}
                    >
                         <GridColumn field="fileName" title="File" />
                         <GridColumn
                              field="uploadedOn"
                              title="Uploaded"
                              cells={{
                                   data: (cellProps) => (
                                        <td>
                                             {cellProps.dataItem.uploadedOn
                                                  ? new Date(cellProps.dataItem.uploadedOn).toLocaleString()
                                                  : ""}
                                        </td>
                                   ),
                              }}
                         />
                         <GridColumn field="total" title="Rows" />
                         <GridColumn field="succeeded" title="Imported" />
                         <GridColumn field="failed" title="Failed" />
                         <GridColumn field="campaignSummary" title="Campaign" />
                    </Grid>
               )}
          </Box>
     );
}
